import BossModel from "@/models/BossModel";

export default class MediaLibraryTag extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'media-library-tag';

    /**
     *
     * @type {string}
     */
    static entity = 'mediaLibraryTags';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new MediaLibraryTag(data[key]));
            }
            return instances;
        });
    }

    /**
     *
     * @param name
     * @param parentId
     * @returns {Promise<AxiosResponse<T>>}
     */
    static create(name, parentId = null) {
        return this.api().create({name: name, media_library_folder_parent_id: parentId});
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    restore() {
        return this.constructor.api().action('restore/' + this.id).getSingle();
    }



}
